import type { IGraphConfig } from '~/types/graph-config'

import { SECTION_NAME } from './sections'

import {
  businessReport_lineSerieOptions,
  businessReport_lineWithTrendSerieOptions,
  businessReport_refundsUnitAndRevenueOptions,
  businessReport_stackedColumnOptions,
  businessReport_columnSerieOptions,
  businessReport_marginMonthlyOptions,
  businessReport_spendAndRevenueMonthlyColumnOptions,
} from '~/views/Analytics/Reporting/Reporting/chart-options'

export const GRAPH_KEY_MAP: Record<string, IGraphConfig> = {
  ui_br_downloads_daily: {
    backendDataKey: 'ui_br_downloads_daily',
    hasFavourite: true,
    options: businessReport_lineWithTrendSerieOptions(),
    section: SECTION_NAME.business_report,
    subsection: 'Download',
    title: 'Downloads - Daily',
    type: 'graph',
  },
  ui_br_downloads_monthly: {
    backendDataKey: 'ui_br_downloads_monthly',
    hasFavourite: true,
    options: businessReport_columnSerieOptions(),
    section: SECTION_NAME.business_report,
    subsection: 'Download',
    title: 'Downloads - Monthly',
    type: 'graph',
  },
  ui_br_refunds_revenue_by_subtype_daily: {
    backendDataKey: 'ui_br_refunds_revenue_by_subtype_daily',
    hasFavourite: true,
    options: businessReport_stackedColumnOptions({ isMoney: true }),
    section: SECTION_NAME.business_report,
    subsection: 'Refunds',
    title: 'Refunds Revenue - Low Level - Daily',
    type: 'graph',
  },
  ui_br_refunds_revenue_by_type_daily: {
    backendDataKey: 'ui_br_refunds_revenue_by_type_daily',
    hasFavourite: true,
    options: businessReport_stackedColumnOptions({ isMoney: true }),
    section: SECTION_NAME.business_report,
    subsection: 'Refunds',
    title: 'Refunds Revenue - High Level - Daily',
    type: 'graph',
  },
  ui_br_refunds_units_by_subtype_daily: {
    backendDataKey: 'ui_br_refunds_units_by_subtype_daily',
    hasFavourite: true,
    options: businessReport_stackedColumnOptions(),
    section: SECTION_NAME.business_report,
    subsection: 'Refunds',
    title: 'Refunds Units - Low Level - Daily',
    type: 'graph',
  },
  ui_br_refunds_units_by_type_daily: {
    backendDataKey: 'ui_br_refunds_units_by_type_daily',
    hasFavourite: true,
    options: businessReport_stackedColumnOptions(),
    section: SECTION_NAME.business_report,
    subsection: 'Refunds',
    title: 'Refunds Units - High Level - Daily',
    type: 'graph',
  },
  ui_br_refunds_units_revenue_daily: {
    backendDataKey: 'ui_br_refunds_units_revenue_daily',
    hasFavourite: true,
    options: businessReport_refundsUnitAndRevenueOptions,
    section: SECTION_NAME.business_report,
    subsection: 'Refunds',
    title: 'Refunds Units & Revenue - Daily',
    type: 'graph',
  },
  ui_br_refunds_units_revenue_monthly: {
    backendDataKey: 'ui_br_refunds_units_revenue_monthly',
    hasFavourite: true,
    options: businessReport_refundsUnitAndRevenueOptions,
    section: SECTION_NAME.business_report,
    subsection: 'Refunds',
    title: 'Refunds Units & Revenue - Monthly',
    type: 'graph',
  },
  ui_br_revenue_distribution_details_daily: {
    backendDataKey: 'ui_br_revenue_distribution_details_daily',
    hasFavourite: true,
    options: businessReport_stackedColumnOptions({ isMoney: true }),
    section: SECTION_NAME.business_report,
    subsection: 'Revenue Distribution',
    title: 'Revenue Distribution - Low Level - Daily',
    type: 'graph',
  },
  ui_br_revenue_distribution_details_monthly: {
    backendDataKey: 'ui_br_revenue_distribution_details_monthly',
    hasFavourite: true,
    options: businessReport_stackedColumnOptions({ isMoney: true }),
    section: SECTION_NAME.business_report,
    subsection: 'Revenue Distribution',
    title: 'Revenue Distribution - Low Level - Monthly',
    type: 'graph',
  },
  ui_br_revenue_distribution_summary_daily: {
    backendDataKey: 'ui_br_revenue_distribution_summary_daily',
    hasFavourite: true,
    options: businessReport_stackedColumnOptions({ isMoney: true }),
    section: SECTION_NAME.business_report,
    subsection: 'Revenue Distribution',
    title: 'Revenue Distribution - High Level - Daily',
    type: 'graph',
  },
  ui_br_revenue_distribution_summary_monthly: {
    backendDataKey: 'ui_br_revenue_distribution_summary_monthly',
    hasFavourite: true,
    options: businessReport_stackedColumnOptions({ isMoney: true }),
    section: SECTION_NAME.business_report,
    subsection: 'Revenue Distribution',
    title: 'Revenue Distribution - High Level - Monthly',
    type: 'graph',
  },
  ui_br_spend_revenue_daily: {
    backendDataKey: 'ui_br_spend_revenue_daily',
    hasFavourite: true,
    options: businessReport_lineSerieOptions({ isMoney: true }),
    section: SECTION_NAME.business_report,
    subsection: 'Spend & Revenue',
    title: 'Spend & Revenue - Daily',
    type: 'graph',
  },
  ui_br_spend_revenue_margin: {
    backendDataKey: 'ui_br_spend_revenue_margin',
    hasFavourite: true,
    options: businessReport_marginMonthlyOptions,
    section: SECTION_NAME.business_report,
    subsection: 'Spend & Revenue',
    title: 'Spend & Revenue - Monthly Margin',
    type: 'graph',
  },
  ui_br_spend_revenue_monthly: {
    backendDataKey: 'ui_br_spend_revenue_monthly',
    hasFavourite: true,
    options: businessReport_spendAndRevenueMonthlyColumnOptions,
    section: SECTION_NAME.business_report,
    subsection: 'Spend & Revenue',
    title: 'Spend & Revenue - Monthly',
    type: 'graph',
  },
  ui_br_spend_revenue_weekly: {
    backendDataKey: 'ui_br_spend_revenue_weekly',
    hasFavourite: true,
    options: businessReport_lineSerieOptions({ isMoney: true }),
    section: SECTION_NAME.business_report,
    subsection: 'Spend & Revenue',
    title: 'Spend & Revenue - Weekly',
    type: 'graph',
  },
  ui_br_subscriptions_active_details_daily: {
    backendDataKey: 'ui_br_subscriptions_active_details_daily',
    hasFavourite: true,
    options: businessReport_stackedColumnOptions(),
    section: SECTION_NAME.business_report,
    subsection: 'Subscriptions',
    title: 'Active Subscriptions - Units by IAP - Daily',
    type: 'graph',
  },
  ui_br_subscriptions_active_summary_daily: {
    backendDataKey: 'ui_br_subscriptions_active_summary_daily',
    hasFavourite: true,
    options: businessReport_stackedColumnOptions(),
    section: SECTION_NAME.business_report,
    subsection: 'Subscriptions',
    title: 'Active Subscriptions - Units by Type - Daily',
    type: 'graph',
  },
  ui_br_subscriptions_freetrial_details_daily: {
    backendDataKey: 'ui_br_subscriptions_freetrial_details_daily',
    hasFavourite: true,
    options: businessReport_stackedColumnOptions(),
    section: SECTION_NAME.business_report,
    subsection: 'Subscriptions',
    title: 'Free Trials - Units by IAP - Daily',
    type: 'graph',
  },
  ui_br_subscriptions_freetrial_details_monthly: {
    backendDataKey: 'ui_br_subscriptions_freetrial_details_monthly',
    hasFavourite: true,
    options: businessReport_stackedColumnOptions(),
    section: SECTION_NAME.business_report,
    subsection: 'Subscriptions',
    title: 'Free Trials - Units by IAP - Monthly',
    type: 'graph',
  },
  ui_br_subscriptions_freetrial_summary_daily: {
    backendDataKey: 'ui_br_subscriptions_freetrial_summary_daily',
    hasFavourite: true,
    options: businessReport_stackedColumnOptions(),
    section: SECTION_NAME.business_report,
    subsection: 'Subscriptions',
    title: 'Free Trials - Units by Type - Daily',
    type: 'graph',
  },
  ui_br_subscriptions_freetrial_summary_monthly: {
    backendDataKey: 'ui_br_subscriptions_freetrial_summary_monthly',
    hasFavourite: true,
    options: businessReport_stackedColumnOptions(),
    section: SECTION_NAME.business_report,
    subsection: 'Subscriptions',
    title: 'Free Trials - Units by Type - Monthly',
    type: 'graph',
  },
}
